import { IconProps } from ".";

export const ProfileModernIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.9165C8.61929 2.9165 7.5 4.03579 7.5 5.4165C7.5 6.79722 8.61929 7.9165 10 7.9165C11.3807 7.9165 12.5 6.79722 12.5 5.4165C12.5 4.03579 11.3807 2.9165 10 2.9165ZM6.25 5.4165C6.25 3.34544 7.92893 1.6665 10 1.6665C12.0711 1.6665 13.75 3.34544 13.75 5.4165C13.75 7.48757 12.0711 9.1665 10 9.1665C7.92893 9.1665 6.25 7.48757 6.25 5.4165ZM10 11.6665C7.44951 11.6665 5.53037 13.1689 4.73826 15.3107C4.65294 15.5414 4.70263 15.7535 4.84912 15.9281C5.00423 16.1129 5.26948 16.2498 5.5807 16.2498H14.4193C14.7305 16.2498 14.9958 16.1129 15.1509 15.9281C15.2974 15.7535 15.3471 15.5414 15.2617 15.3107C14.4696 13.1689 12.5505 11.6665 10 11.6665ZM3.56587 14.8771C4.52961 12.2713 6.89857 10.4165 10 10.4165C13.1014 10.4165 15.4704 12.2713 16.4341 14.8771C16.6895 15.5675 16.5159 16.2459 16.1084 16.7315C15.7096 17.2069 15.0902 17.4998 14.4193 17.4998H5.5807C4.90981 17.4998 4.29042 17.2069 3.89157 16.7315C3.4841 16.2459 3.31052 15.5675 3.56587 14.8771Z"
        fill="currentColor"
      />
    </svg>
  );
};
